<template>
  <div class="drawer-overlay" @click.self="$emit('close')">
    <div class="drawer-panel">

      <!-- HEADER -->
      <div class="drawer-header">
        <div class="header-left">
          <h2 class="title">{{ post.title }}</h2>

          <span class="type-badge" :class="'type-' + post.freelanceType">
            {{ post.freelanceType }}
          </span>
        </div>

        <button class="close-button" @click="$emit('close')">&times;</button>
      </div>

      <!-- CONTENT -->
      <div class="drawer-content">

        <p class="date">{{ post.relativeDate }}</p>

        <p class="text">{{ post.cleanText }}</p>

        <!-- Hashtags -->
        <div class="hashtags" v-if="post.hashtags?.length">
          <span v-for="tag in post.hashtags" :key="tag" class="tag">
            {{ tag }}
          </span>
        </div>

        <!-- Contact Button -->
        <button class="action-btn" @click="openLink">
          <img v-if="contactIcon" :src="contactIcon" class="icon" />
          Откликнуться
        </button>

      </div>

    </div>
  </div>
</template>

<script setup>

import { computed } from "vue";
  
  const props = defineProps({
    freelance: { type: Object, required: true }
  });
  
  // Пост удобнее назвать post
  const post = computed(() => props.freelance);
  
  // Иконка
  const contactIcon = computed(() => {
    switch (post.value.contactType) {
      case "telegram": return "/freelance_tg.png";
      case "email":    return "/freelance_email.png";
      case "google":   return "/freelance_google.png";
      case "yandex":   return "/freelance_yandex.png";
      default: return null;
    }
  });
  
  // Открытие ссылки
  function openLink() {
    if (!post.value.actionUrl) return;
    window.open(post.value.actionUrl, "_blank");
  }

  </script>

<style scoped>
  
  .drawer-overlay {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.35);
    display: flex;
    z-index: 1000;
  }
  
  .drawer-panel {
    width: 450px;
    background: #fff;
    padding: 24px;
    animation: slideIn 0.25s ease-out;
    display: flex;
    flex-direction: column;
  }
  
  [data-theme="dark"] .drawer-panel {
    background: #1f1f1f;
  }
  
  @keyframes slideIn {
    from { transform: translateX(-100%); }
    to { transform: translateX(0); }
  }
  
  /* Header */
  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .header-left {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .title {
    font-family: "Eastman-Bold";
    font-size: 20px;
    margin: 0;
  }
  
  /* freelanceType badge */
  .type-badge {
    padding: 6px 12px;
    border-radius: 12px;
    font-size: 11px;
    width: fit-content;
  }
  .type-design      { background: #d5f7d8; color: #2b8c36; }
  .type-marketing   { background: #d6e9ff; color: #3478f6; }
  .type-copywriting { background: #ffe9cc; color: #d67a00; }
  .type-video       { background: #ffd6d6; color: #ff4b4b; }
  .type-other       { background: #e4d7ff; color: #7e3ff2; }
  
  .close-button {
    border: none;
    background: transparent;
    font-size: 28px;
    cursor: pointer;
    color: var(--text-primary);
  }
  
  /* Content */
  .drawer-content {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
  
  .date {
    color: #777;
    font-size: 13px;
  }
  
  .text {
    font-size: 15px;
    line-height: 1.45;
    color: var(--text-primary);
  }
  
  /* Hashtags */
  .hashtags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .tag {
    background: #e9f1ff;
    color: #2f5fa5;
    padding: 8px 14px;
    border-radius: 12px;
    font-size: 13px;
  }
  [data-theme="dark"] .tag {
    background: #3d4f66;
    color: #cddcff;
  }
  
  /* Button */
  .action-btn {
    background: #007aff;
    color: white;
    border: none;
    border-radius: 14px;
    padding: 14px;
    font-family: "Eastman-Bold";
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    transition: transform 0.15s ease;
  }
  .action-btn:hover { transform: scale(1.02); }
  .icon { width: 22px; height: 22px; }
  </style>